export interface WishlistItem {
  id: string;
  productId: string;
  name: string;
  price: number;
  originalPrice?: number;
  imageUrl: string;
  category: string;
  description: string;
  detailUrl: string;
}

const wishlistKey = (userId: string) => `sf_wishlist_${userId}`;

const getItems = (userId: string): WishlistItem[] => {
  try { return JSON.parse(localStorage.getItem(wishlistKey(userId)) || '[]'); } catch { return []; }
};

const save = (userId: string, items: WishlistItem[]) =>
  localStorage.setItem(wishlistKey(userId), JSON.stringify(items));

export const wishlistService = {
  getWishlist(userId: string): WishlistItem[] {
    return getItems(userId);
  },

  addToWishlist(userId: string, item: WishlistItem): WishlistItem[] {
    const items = getItems(userId);
    if (!items.find(i => i.productId === item.productId)) {
      const updated = [...items, item];
      save(userId, updated);
      return updated;
    }
    return items;
  },

  removeFromWishlist(userId: string, productId: string): WishlistItem[] {
    const items = getItems(userId).filter(i => i.productId !== productId);
    save(userId, items);
    return items;
  },

  clearWishlist(userId: string): void {
    localStorage.removeItem(wishlistKey(userId));
  },

  isInWishlist(userId: string, productId: string): boolean {
    return getItems(userId).some(i => i.productId === productId);
  },

  getCount(userId?: string): number {
    if (!userId) return 0;
    return getItems(userId).length;
  },

  toggle(userId: string, item: WishlistItem): { added: boolean; items: WishlistItem[] } {
    if (wishlistService.isInWishlist(userId, item.productId)) {
      return { added: false, items: wishlistService.removeFromWishlist(userId, item.productId) };
    }
    return { added: true, items: wishlistService.addToWishlist(userId, item) };
  },
};
